


















import Vue from 'vue'

export default Vue.extend({
  name: 'MainContainer',

  props: {
    /* 
    Sizes: tiny: 464px, small: 624px, smallish: 720px, medium: 972px,
    big: 1024px, large: 1190px, full: Full screen - 60px $full-width-xl-padded */
    size: {
      type: String,
      required: true,
    },
    noBottomPadding: {
      type: Boolean,
      default: false,
    },
    noTopPadding: {
      type: Boolean,
      default: false,
    },
  },
})
